import { StationPriceTableHeaderProps } from './StationPriceTableHeader.types';

export function StationPriceTableHeader({ fuelTypes, headerRef }: StationPriceTableHeaderProps): JSX.Element {
  return (
    <div className="price-processing-stations-header-wrapper" ref={headerRef}>
      <div className="price-processing-table">
        <div className="price-processing-table-header">
          <div className="price-processing-header-cell price-processing-region-col">Регіон</div>
          <div className="price-processing-header-cell price-processing-province-col">Область</div>
          <div className="price-processing-header-cell price-processing-brand-col">Бренд</div>
          <div className="price-processing-header-cell price-processing-address-col">Адреса</div>
          <div className="price-processing-header-cell price-processing-last-date-col">Остання дата зміни цін</div>
          {fuelTypes.map(fuel => (
            <div key={fuel} className="price-processing-header-cell price-processing-fuel-col">
              {fuel}
            </div>
          ))}
          <div className="price-processing-header-cell price-processing-date-col">Дата зміни цін</div>
        </div>
      </div>
    </div>
  );
}
